var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solan-t-container"},[_c('SolanHeaderT',{staticClass:"solan-t-header",attrs:{"app-state-store":_vm.appStateStore}}),_c('router-view',{staticClass:"solan-t-main"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }